import React from 'react';
import { Select } from 'antd';
import { cn } from './_cn';
import FieldLabel from './field-label';

const TWSelect = ({
  label,
  labelIcon,
  error,
  hint,
  options,
  size = 'large',
  showSearch = true,
  allowClear = true,
  optionFilterProp = 'label',
  required,
  id,
  className = '',
  wrapperClassName = '',
  children,
  ...rest
}) => {
  const generatedId = React.useId();
  const selectId = id || generatedId;
  const hasError = Boolean(error);
  return (
    <div className={cn('w-full', wrapperClassName)}>
      {label ? (
        <FieldLabel htmlFor={selectId} icon={labelIcon} required={required}>
          {label}
        </FieldLabel>
      ) : null}
      <Select
        id={selectId}
        size={size}
        style={{ width: '100%' }}
        showSearch={showSearch}
        allowClear={allowClear}
        optionFilterProp={optionFilterProp}
        status={hasError ? 'error' : undefined}
        options={options}
        className={cn('tw-select', className)}
        {...rest}
      >
        {children}
      </Select>
      {error || hint ? (
        <p
          className={cn(
            'mt-1 text-xs',
            hasError
              ? 'text-rose-600 dark:text-rose-400'
              : 'text-slate-500 dark:text-slate-400',
          )}
        >
          {error || hint}
        </p>
      ) : null}
    </div>
  );
};

TWSelect.Option = Select.Option;
TWSelect.OptGroup = Select.OptGroup;

export default TWSelect;
